import { createContext, useContext, useState, useMemo, useCallback } from 'react';

// Lightweight context the PublicPageRenderer uses to broadcast the current
// page's `page_type` (e.g. "marketing", "legal") AND any per-page preset
// overrides to the shared PublicLayout chrome (PublicNav, PublicFooter).
// Falls back to the layout's static prop / type-assignment when no value
// has been published.
const PageTypeContext = createContext({
  pageType: null,
  navPresetOverride: null,
  footerPresetOverride: null,
  setPageMeta: () => {},
});

export function PageTypeProvider({ children }) {
  const [state, setState] = useState({
    pageType: null,
    navPresetOverride: null,
    footerPresetOverride: null,
  });
  const setPageMeta = useCallback((next) => {
    setState((prev) => ({ ...prev, ...next }));
  }, []);
  const value = useMemo(() => ({ ...state, setPageMeta }), [state, setPageMeta]);
  return <PageTypeContext.Provider value={value}>{children}</PageTypeContext.Provider>;
}

export function usePageTypeContext() {
  return useContext(PageTypeContext);
}
